import IntTypes from './int-types.js';
import FloatTypes from './float-types.js';
import PixelTypes from './pixel-types.js';
class MeshType {
    dimension;
    pointComponentType;
    pointPixelComponentType;
    pointPixelType;
    pointPixelComponents;
    cellComponentType;
    cellPixelComponentType;
    cellPixelType;
    cellPixelComponents;
    constructor(dimension = 2, pointComponentType = FloatTypes.Float32, pointPixelComponentType = FloatTypes.Float32, pointPixelType = PixelTypes.Scalar, pointPixelComponents = 1, cellComponentType = IntTypes.Int32, cellPixelComponentType = FloatTypes.Float32, cellPixelType = PixelTypes.Scalar, cellPixelComponents = 1) {
        this.dimension = dimension;
        this.pointComponentType = pointComponentType;
        this.pointPixelComponentType = pointPixelComponentType;
        this.pointPixelType = pointPixelType;
        this.pointPixelComponents = pointPixelComponents;
        this.cellComponentType = cellComponentType;
        this.cellPixelComponentType = cellPixelComponentType;
        this.cellPixelType = cellPixelType;
        this.cellPixelComponents = cellPixelComponents;
    }
}
export default MeshType;
//# sourceMappingURL=mesh-type.js.map